<template>
  <v-footer app height="30" class="pa-0">
    <v-container class="pa-0 ma-0" fluid>
      <div class="text-center caption grey--text">
        {{ text }}
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    text: "@2025, PT. CNA INNILABS INDONESIA"
  })
}
</script>